import styled from 'styled-components';

export const SCSessionWrapper = styled.div`
    width: inherit;
`;
